module.exports = __webpack_public_path__ + "img/hero_bookings.2e523cf4.jpg";